import { MultiLangString } from '@/models/general';

export type Webshop = {
    id?: string;
    active: boolean;
    liftOperatorId: string;
    vanityIdentifier: string;
    integrationToken: string;
    primaryColor: string;
    primaryLightColor: string;
    imprintUrl: MultiLangString;
    dataPrivacyUrl: MultiLangString;
    termsAndConditionsUrl: MultiLangString;
    headerImageUrl: string;
    logoUrl: string;
    tagManagerCode: string;
    dayTicketsButtonText: MultiLangString;
    seasonTicketsButtonText: MultiLangString;
    buttonTextColor: string;
    buttonBackgroundColor: string;
    filterTextColor: string;
    filterBackgroundColor: string;
};

export type CreateWebshop = Omit<Webshop, 'id'>;

export const createNewWebshop = (): CreateWebshop => ({
    active: true,
    liftOperatorId: '',
    vanityIdentifier: '',
    integrationToken: '',
    primaryColor: '',
    primaryLightColor: '',
    imprintUrl: {
        de: '',
        en: '',
    },
    dataPrivacyUrl: {
        de: '',
        en: '',
    },
    termsAndConditionsUrl: {
        de: '',
        en: '',
    },
    headerImageUrl: '',
    logoUrl: '',
    tagManagerCode: '',
    dayTicketsButtonText: {
        de: '',
        en: '',
    },
    seasonTicketsButtonText: {
        de: '',
        en: '',
    },
    buttonTextColor: '',
    buttonBackgroundColor: '',
    filterTextColor: '',
    filterBackgroundColor: '',
});

export const isOfTypeWebshop = (
    webshop: Webshop | CreateWebshop
): webshop is Webshop => !!webshop?.['id'];
